var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-item',_vm._b({},'form-item',_vm.formItemProps,false),[_c('el-input',_vm._b({attrs:{"value":_vm.value || '',"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":_vm.handleChange}},'el-input',_vm.additionProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }